/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ companyName: NonNullable<unknown> }} Home_Unlock_Card3_DescInputs */

const en_home_unlock_card3_desc = /** @type {(inputs: Home_Unlock_Card3_DescInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Get exclusive services included with your ${i?.companyName} coverage.`)
};

const fr_home_unlock_card3_desc = /** @type {(inputs: Home_Unlock_Card3_DescInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Accédez aux services exclusifs inclus dans votre couverture ${i?.companyName}.`)
};

/**
* | output |
* | --- |
* | "Get exclusive services included with your {companyName} coverage." |
*
* @param {Home_Unlock_Card3_DescInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const home_unlock_card3_desc = /** @type {((inputs: Home_Unlock_Card3_DescInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Unlock_Card3_DescInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_unlock_card3_desc(inputs)
	return fr_home_unlock_card3_desc(inputs)
});